import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl } from '../../common/rcs_gaz_mc_core_FE';
import PreferredStar from '../PreferredStar';
import { RaceRowWrapper } from './styles';
import TeamLabel from '../TeamLabel';
import Label from '../shared/Label';
import TimingRace from '../TimeResults/TimingRace';
import LapsCounter from '../TimeResults/LapsCounter';
import IconFont from '../../components/shared/IconFont';
import LocalStorageUtility from '../../common/localStorageUtility/localStorageUtility';
import * as raceStatus from '../../constants';
import ConfigManager from '../../common/configManager/configManager';

const RaceRow = ({
  raceRow, actions, dictionary, isMobile, date,
  sportId, isHighlight, isDeskFav, competitionId,
  laps, raceTrack,
}) => {
  const countriesUrl = ConfigManager.getCountriesFlag();
  const handleFavourites = () => {
    if (!isDeskFav) {
      if (!LocalStorageUtility.isPreferred(raceRow.get('id'))) {
        actions.showTooltip();
        setTimeout(() => {
          actions.hideTooltip();
        }, 2500);
      }
      actions.favouriteGame(sportId, raceRow.get('id'));
      actions.setFavouritesOnCompetition(raceRow.get('id'));
    } else {
      actions.removefavouriteGame(sportId, raceRow.get('id'), date);
    }
  };
  const isLive = () => (raceRow.get('trackStatus') === raceStatus.ON_TRACK);
  const labelPilot = (pilot) => {
    if (pilot.get('time') === '' || !pilot.get('time')) {
      return `${pilot.get('pos')}°`;
    }
    if (raceRow.get('session') === 'QUALI' || raceRow.get('session') === 'SUPERPOLE') {
      const status = pilot.get('status');
      const time = pilot.get('time');
      if (time && typeof time === 'string') return time;
      return `${time && time.get(status) ? time.get(status) : ''}`;
    }
    if (Number(pilot.get('pos'))) {
      const isFirst = Number(pilot.get('pos')) === 1
      return `${isFirst ? '' : '+'}${pilot.get('time')}`
    }
    return '';
  };

  const showDrivers = () => (raceRow && raceRow.get('trackStatus') !== raceStatus.NOTSTARTED && raceRow.get('drivers') && raceRow.get('drivers').size > 0);

  return (
    <RaceRowWrapper
      isHighlight={isHighlight}
      {... raceRow.get('trackStatus') !== raceStatus.ABORTED ? {href: prettyMatchUrl(raceTrack.toLowerCase(), raceTrack.toLowerCase(), raceRow.get('matchId'), sportId, competitionId, process.env.REACT_APP_SITE)} : {}}
    >
      <Row style={{
        width: '100%',
        marginRight: '0',
        marginLeft: '0',
        marginBottom: showDrivers() ? '20px' : '0px',
        alignItems: 'center',
      }}
      >
        <Col
          onClick={event => event.preventDefault()}
          lg={1}
          md={1.2}
          sm={1.2}
          xs={1.2}
          style={{
            paddingLeft: '8px',
            paddingRight: '0px',
          }}
        >
          <PreferredStar handleFavourites={handleFavourites} isSelected={raceRow.get('favourite')} />
        </Col>
        <Col
          lg={4.65}
          md={5.5}
          sm={5.5}
          xs={5.5}
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'row',
            paddingRight: '10px',
            paddingLeft: isMobile ? '5px' : '0px',
            overflow: 'initial',
          }}
        >
          <Label
            label={`${dictionary.competitionTable.gpPhases[raceRow.get('session')]}`}
            size={0.85}
            weight="bold"
          />
        </Col>
        <Col
          lg={5}
          md={3.7}
          sm={3.7}
          xs={3.7}
          style={{
            overflow: 'initial',
          }}
        >
          {(raceRow.get('session') === raceStatus.RACE && (raceRow.get('trackStatus') === raceStatus.ON_TRACK || raceRow.get('trackStatus') === raceStatus.SAFETY_CAR || raceRow.get('trackStatus') === raceStatus.RED_FLAG || raceRow.get('trackStatus') === raceStatus.YELLOW_FLAG))
            ?
              <LapsCounter
                laps={laps}
                currenteLap={`${raceRow.getIn(['drivers', 0, 'laps'])}`}
                justify={isMobile && 'flex-start'}
                safetyCar={raceRow.get('trackStatus') === raceStatus.SAFETY_CAR}
              />
            :
              <TimingRace
                status={raceRow.get('trackStatus')}
                dictionary={dictionary}
                isLive={isLive()}
                startDate={raceRow.get('start')} // data prevista
                startTime={raceRow.get('startTime')} // inizio effettivo
                justify={isMobile && 'flex-start'}
                actions={actions}
              />
          }
        </Col>
        <Col
          lg={1.35}
          md={1.6}
          sm={1.6}
          xs={1.6}
          style={{
            display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', paddingRight: '10px', paddingLeft: '15px',
          }}
        >
          <IconFont
            className="icon-matchcenter-right-arrow"
            color="selectedColor"
            font={18}
            weight="bold"
            withCursor
          />
        </Col>
      </Row>
      {showDrivers() && raceRow.get('drivers').slice(0, 3).map((pilot, index) => (
        <Row
          key={index}
          style={{
            width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
          }}
        >
          <Col
            lg={0.7}
            md={0.9}
            sm={0.9}
            xs={0.9}
            style={{
              paddingLeft: '0px',
              paddingRight: '0px',
            }}
            offset={{
              lg: 1,
              md: 1.3,
              sm: 1.3,
              xs: 1.3,
            }}
          >
            <TeamLabel
              image={`${countriesUrl}${pilot.get('nat')}.jpg`}
              isFlag
            />

          </Col>
          <Col
            lg={3.2}
            md={5}
            sm={5}
            xs={5}
            style={{
              paddingLeft: isMobile ? '7px' : '0px',
              paddingRight: '0px',
              textAlign: 'left',
            }}
          >
            <Label
              label={pilot.get('driver')}
              weight={Number(pilot.get('pos')) === 1 ? 'bold' : 'normale'}
              size={isMobile ? 0.8 : 1}
            />
          </Col>
          {!isMobile &&
            <Col
              lg={3.2}
              md={3.2}
              sm={3.2}
              xs={3.2}
              style={{
                paddingLeft: '0px',
                paddingRight: '0px',
                textAlign: 'left',
              }}
            >
              <Label
                label={pilot.get('team')}
                weight={Number(pilot.get('pos')) === 1 ? 'bold' : 'normale'}
              />
            </Col>
          }
          <Col
            lg={2.5}
            md={2.5}
            sm={2.5}
            xs={2.5}
            style={{
              paddingLeft: '0px',
              paddingRight: '0px',
              textAlign: isMobile ? 'left' : 'right',
              overflow: 'initial',
            }}
          >
            <Label
              label={labelPilot(pilot)}
              weight={Number(pilot.get('pos')) === 1 ? 'bold' : 'normale'}
              color={isLive() ? 'liveColor' : 'black'}
              size={isMobile ? 0.9 : 1}
            />
          </Col>
        </Row>
      ))}

    </RaceRowWrapper>
  );
};

RaceRow.propTypes = {
  raceRow: PropTypes.any,
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  date: PropTypes.string,
  sportId: PropTypes.any,
  isHighlight: PropTypes.bool,
  isDeskFav: PropTypes.bool,
  competitionId: PropTypes.any,
  laps: PropTypes.any,
  raceTrack: PropTypes.any,
};

export default RaceRow;
